import script from "./EmptyCart.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyCart.vue?vue&type=script&setup=true&lang=js"

import "./EmptyCart.vue?vue&type=style&index=0&id=25cd33c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25cd33c4"]])

export default __exports__